var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/*global gardenFormUtil*/
import { gardenFormUtil } from './garden-form-util';
jQuery(function () {
    var form = $('#map-image-upload-form');
    if (form.length < 1) {
        return;
    }
    var validImageTypes = ['image/jpeg', 'image/png'];
    var fileType;
    var imgUrl;
    var imgRef;
    var imgFallback = $('#map-image').data('fallback');
    var loader = form.find('.loader');
    $('#map-image-upload-input').change(function () {
        gardenFormUtil.disableUploadBtn();
        addLoader();
        var file = this.files[0];
        gardenFormUtil.hideErrors();
        if (file) {
            fileType = file['type'];
            $('#map-image-filename').val(file.name);
            $('#map-image-filename').removeClass('hidden');
            checkAndUploadFile(file);
        }
        else {
            removeLoader();
            gardenFormUtil.showGenericError();
            $('#map-image-filename').addClass('hidden');
        }
    });
    function checkAndUploadFile(file) {
        if ($.inArray(fileType, validImageTypes) < 0) {
            gardenFormUtil.showError('Filen du har valt är av fel format.');
            removeLoader();
        }
        else if (file.size > 10000000) {
            gardenFormUtil.showError('Filen du har valt överstiger gränsen 10 MB.');
            removeLoader();
        }
        else {
            var img_1 = new Image();
            var objectUrl = window.URL.createObjectURL(file);
            img_1.onload = function () {
                if (img_1.width < 800 && img_1.width < img_1.height) {
                    gardenFormUtil.showError('Vi rekommenderar att du använder en bild som är kvadratisk eller en liggande rektangel och är över 800 pixlar bred för att få en bra användarupplevelse.', true);
                }
                else if (img_1.width < 800) {
                    gardenFormUtil.showError('Bilden du har valt är under 800 pixlar i bredd. Vi rekommenderar att du väljer en större bild för bästa möjliga kvalitet.', true);
                }
                else if (img_1.width < img_1.height) {
                    gardenFormUtil.showError('Bilden du har valt är en stående rektangel. Vi rekommenderar att du väljer en bild som är kvadratisk eller en liggande rektangel för att få en bra användarupplevelse.', true);
                }
                else {
                    gardenFormUtil.hideErrors();
                }
                var url = uploadImageToServer(file);
                imgUrl = url;
            };
            img_1.src = objectUrl;
        }
    }
    function uploadImageToServer(file) {
        var formData = new FormData();
        formData.append('file', file);
        var antiForgery = $('.js-anti-forgery' + ' input').val().toString();
        formData.append('__RequestVerificationToken', antiForgery);
        $.ajax({
            url: '/min-tradgard/vaxtplats/ladda-upp-bild',
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (data) {
                var json = JSON.parse(data);
                if (json.success) {
                    setImageUrl(json);
                    removeLoader();
                    gardenFormUtil.enableUploadBtn();
                }
                else {
                    gardenFormUtil.showGenericError();
                    removeLoader();
                }
            },
            error: function () {
                gardenFormUtil.showGenericError();
                removeLoader();
            }
        });
    }
    $('#map-upload-btn').on('click', function (e) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                e.preventDefault();
                if (imgUrl && imgRef) {
                    $('.js-input-imageurl').val(imgRef);
                    $('#map-image').attr('src', imgUrl);
                    $('#map-image-filename').addClass('hidden');
                    $(this).closest('.popup-overlay').removeClass('visible');
                    imgUrl = null;
                }
                else {
                    gardenFormUtil.showGenericError();
                }
                return [2 /*return*/];
            });
        });
    });
    $('#map-reset-image').on('click', function () {
        $('#map-image').attr('src', imgFallback);
        $('.js-input-imageurl').val(null);
        $(this).closest('.popup-overlay').removeClass('visible');
    });
    $('.js-map-image-upload-btn').on('click', function () {
        gardenFormUtil.disableUploadBtn();
        gardenFormUtil.hideErrors();
        $('#map-image-filename').addClass('hidden');
        $('#map-image-upload-popup').closest('.popup-overlay').addClass('visible');
    });
    function setImageUrl(json) {
        imgUrl = json.uri;
        imgRef = json.name;
    }
    function addLoader() {
        $('.js-map-image-upload-content').css('visibility', 'hidden');
        loader.removeClass('hidden');
    }
    function removeLoader() {
        $('.js-map-image-upload-content').css('visibility', 'visible');
        loader.addClass('hidden');
    }
});
